module.exports = __webpack_public_path__ + "TopoMap-74101868a8eba328dc00e9d0411c0d6d.svg";